import { Component, Input, OnChanges, QueryList, SimpleChanges, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { concatMap, filter, map, shareReplay } from 'rxjs/operators';
import { ItineraryStepDocumentConfigEntity } from 'src/app/developer/models/itinerary-step-document-config-entity';
import { DataFieldGroup } from '../../shared/datafields/models';
import { DistributionItineraryStepComponent } from '../distribution-itinerary-step/distribution-itinerary-step.component';
import { Distribution, DocumentConfig } from '../models';
import { DistributionItineraryConfig, DistributionItineraryConfigSaveObject, DistributionItineraryStepConfigSaveObject } from '../models/distribution-itinerary-config';
import { DistributionService } from '../services';


@Component({
    selector: 'app-distribution-itinerary',
    templateUrl: './distribution-itinerary.component.html',
    styleUrls: ['./distribution-itinerary.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DistributionItineraryStepComponent]
})
export class DistributionItineraryComponent implements OnChanges {

    @Input() distribution: Distribution = null;
    @Input() documentConfig: DocumentConfig = null;

    configs: DistributionItineraryConfig[];
    @ViewChildren(DistributionItineraryStepComponent) itineraryStepComponents: QueryList<DistributionItineraryStepComponent>;;

    constructor(
        private distributionService: DistributionService) {
    }

    async ngOnChanges(changes: SimpleChanges) {
        if (changes.documentConfig?.currentValue?.DocumentConfigsId) {
            this.configs = await this.distributionService.getItineraryDocumentConfigsForDistribution(this.documentConfig.DocumentConfigsId, this.distribution.DistributionsId);
        }
        else {
            this.configs = [];
        }
    }

    /**
     * Gets a value indicating whether or not all steps are configured and validates ok.
     * */
    get isValid() {
        return this.itineraryStepComponents.toArray().every(isc => isc.isValid);
    }

    /**
     * Collect all data from the itinerary-steps and store them in a DistributionItineraryConfigSaveObject
     * */
    get allValues(): DistributionItineraryConfigSaveObject {
        const stepConfigSaveObjects = this.configs.map<DistributionItineraryStepConfigSaveObject>(c => {
            return {
                DataFieldValues: DataFieldGroup.getDataFieldValues(c.DataFieldGroups, true),
                Enabled: c.Enabled,
                ItineraryStepId: c.ItineraryStepDocumentConfig.ItineraryStepId,
                ItineraryStepDocumentConfigDistributionId: c.ItineraryStepDocumentConfigDistributionId,
                ItineraryStepDocumentConfigId: c.ItineraryStepDocumentConfig.Id
            } as DistributionItineraryStepConfigSaveObject;
        });

        return { DistributionItineraryStepConfigSaveObjects: stepConfigSaveObjects } as DistributionItineraryConfigSaveObject;
    }
}
